import { useRouter } from 'next/router';
import { memo, useCallback } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { AnonymousSignUpFormWrapper } from '~/components/AnonymousSignUpForm/AnonymousSignUpFormWrapper';
import { AnonymousSignUpModal } from '~/components/PublicLinkAnonymousSignUpModal/AnonymousSignUpModal';
import { useAnonymousSignUpModalLogic } from '~/components/PublicLinkAnonymousSignUpModal/hooks/useAnonymousSignUpModalLogic';
import { AnonymousSignUpModalHeader } from '~/components/PublicLinkAnonymousSignUpModal/shared/AnonymousSignUpModalHeader';

export type PublicCanvasAnonymousSignUpModalProps = {
  onLoggedIn?: () => void;
};

export const PublicCanvasAnonymousSignUpModal = memo(
  ({ onClose, onLoggedIn }: AirModalProps<PublicCanvasAnonymousSignUpModalProps>) => {
    const { asPath } = useRouter();
    const { shortId, objectId } = useShortIdContext();

    const handleLoggedIn = useCallback(() => {
      onClose();
      onLoggedIn?.();
    }, [onClose, onLoggedIn]);

    const { onFullLoginClick, isOpen } = useAnonymousSignUpModalLogic({
      ssoCallbackData: { url: asPath },
      onLoginSuccess: handleLoggedIn,
    });

    return (
      <AnonymousSignUpModal isOpen={isOpen}>
        <AnonymousSignUpModalHeader
          alt="Clouds with paper plane"
          imageSrc="/assets/illustrations/clouds-paper-plane.svg"
        />
        <AnonymousSignUpFormWrapper
          title="A Canvas was shared with you!"
          description="Please enter your info to continue."
          onLoggedIn={handleLoggedIn}
          onFullLoginClick={onFullLoginClick}
          objectType="canvas"
          trackLocation="canvas-share-link"
          objectId={objectId}
          shortId={shortId}
        />
      </AnonymousSignUpModal>
    );
  },
);

PublicCanvasAnonymousSignUpModal.displayName = 'PublicCanvasAnonymousSignUpModal';
